import React from "react";
import classes from "./SecretPage.module.css";
import { useContext, useState, useCallback, useEffect } from "react";
import { UserContext } from "../../context/userContext.js";
import { updateRosbridgeServerIp } from "./Config";
import Home from "./Home";

const SecretPage = () => {

  const [rosBridgeServerIp, setRosBridgeServerIp] = useState(false);

  const [userContext, setUserContext] = useContext(UserContext);

  const logoutHandler = () => {
    fetch(process.env.REACT_APP_API_ENDPOINT + "users/logout", {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userContext.token}`,
      },
    }).then(async (response) => {
      window.localStorage.removeItem("token");
      setUserContext((oldValues) => {
        return { ...oldValues, details: undefined, token: null };
      });
      window.localStorage.setItem("logout", Date.now());
    });
  };

  const fetchUserDetails = useCallback(() => {
    fetch(process.env.REACT_APP_API_ENDPOINT + "users/me", {
      method: "GET",
      credentials: "include",
      // Pass authentication token as bearer token in header
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userContext.token}`,
      },
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json();

        setUserContext((oldValues) => {
          return { ...oldValues, details: data };
        });

        console.log(data.email);

        // Get ip address of Pi bot
        fetch(process.env.REACT_APP_API_ENDPOINT + "bots/ip/get", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userContext.token}`,
          },
          body: JSON.stringify({
            email: data.email,
            botName: "Pi",
          }),
        }).then(async (response) => {
          // console.log(response);
          const value = await response.json();
          console.log(value);
          updateRosbridgeServerIp(value.ipAddress);
          setRosBridgeServerIp(true);
        });
      } else {
        if (response.status === 401) {
          // Edge case: when the token has expired.
          // This could happen if the refreshToken calls have failed due to network error or
          // User has had the tab open from previous day and tries to click on the Fetch button
          //   window.location.reload();
        } else {
          setUserContext((oldValues) => {
            return { ...oldValues, details: null };
          });
        }
      }
    });
  }, [setUserContext, userContext.token]);

  useEffect(() => {
    // fetch only when user details are not present
    if (!userContext.details) {
      fetchUserDetails();
    }
  }, [userContext.details, fetchUserDetails]);

  useEffect(() => {
    const token = window.localStorage.getItem("token");
    if (token) {
      setUserContext((oldValues) => {
        return { ...oldValues, token: token };
      });
    }
  }, [setUserContext]);

  return !userContext.token ? (
    <>
      <div className={classes.secret_layout}>Unautorized Entry</div>
    </>
  ) : (
    <div className={classes.secret_layout}>
      secretPage : TOP SECRET OF AUTOGENBOT
      {userContext.details && (
        <>
          {" "}
          <p>
            Welcome&nbsp;
            <strong>Name: {userContext.details.name}</strong>!
          </p>
          <p>
            <strong>Email: {userContext.details.email}</strong> !
          </p>
          {rosBridgeServerIp && <Home />}
          <button onClick={() => logoutHandler()}>Logout</button>
        </>
      )}
    </div>
  );
};

export default SecretPage;
